import { useTranslation } from 'react-i18next';
import { IoFileTrayFull } from 'react-icons/io5';

import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface INoData {
  emptyMessage?: string;
}

export const NoData = ({ emptyMessage }: INoData) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        height: '10rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      spacing={1}
    >
      <IoFileTrayFull
        aria-hidden
        color={theme.palette.secondary[400]}
        focusable="false"
        size={64}
      />
      <Typography align="center" color="secondary">
        {emptyMessage ?? t('common.grid.no.data')}
      </Typography>
    </Stack>
  );
};
